export const getCurrentUrlParams = () => {
  const currentUrl = new URL(window.location);
  const searchParams = currentUrl.searchParams;
  searchParams.delete('returnTo');
  return searchParams.toString();
};

export const createUrlWithReturnTo = (targetUrl, returnToPath = null) => {
  const paramString = getCurrentUrlParams();
  
  if (!paramString) {
    return targetUrl;
  }
  
  const currentUrl = new URL(window.location);
  const returnPath = returnToPath || (currentUrl.pathname + '?' + paramString);
  return `${targetUrl}?returnTo=${encodeURIComponent(returnPath)}`;
};

export const getReturnToUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const returnTo = urlParams.get('returnTo');
  return returnTo ? decodeURIComponent(returnTo) : null;
};
